import { atom, atomFamily } from "recoil";
import { Uid } from "../types/core";
import { MemberLiveBadge } from "../types/memberLiveBadge";
import { getRecoil, setRecoil } from "../providers/RecoilAccessProvider";

export const memberLiveBadgeState = atomFamily<MemberLiveBadge | undefined, Uid>({
    key: "member.liveBadge",
    default: undefined,
});

// bumped on every badge refresh; filters that read badges via getRecoil depend
// on this so member-list selectors re-evaluate when badges change out-of-band
export const memberLiveBadgesVersionState = atom<number>({
    key: "member.liveBadge.version",
    default: 0,
});

// non-reactive read for code that derives status outside a recoil subscription
// (filters and getBadgeInfo); member-list selectors stay fresh by depending on
// memberLiveBadgesVersionState
export function getMemberLiveBadge(uid: Uid | undefined): MemberLiveBadge | undefined {
    return uid ? getRecoil(memberLiveBadgeState(uid)) : undefined;
}

export function updateMemberLiveBadgesState(uids: Uid[], badges: MemberLiveBadge[]) {
    const badgeByUid = new Map(badges.map(badge => [badge.uid, badge]));
    uids.forEach(uid => setRecoil(memberLiveBadgeState(uid), badgeByUid.get(uid)));
    setRecoil(memberLiveBadgesVersionState, (version) => version + 1);
}
